<template>
  <div>
    <!-- Navbar ของ Staff -->
    <StaffNavbar />
    <div>
      <header class="header">
        <h1>ตั้งค่าผู้ดูแล</h1>
      </header>
      <div class="container-fluid screen-control">
        <div class="py-1 px-5">
          <div class="bg-secondary-light shadow">
            <div style="background-color: #964040" class="text-white p-3">
              <h4>ผู้ดูแล</h4>
              <p class="m-0" id="total_Loan">ทั้งหมด {{ totalUser }} คน</p>
              <div class="d-flex justify-content-start my-2">
                <button class="btn btn-light" @click="addAdminEmail">
                  เพิ่มผู้ดูแล
                </button>
              </div>
            </div>
            <div class="m-2 px-0">
              <div class="table-responsive p-2">
                <table
                  class="table table-light table-striped table-hover table-bordered"
                >
                  <thead>
                    <tr class="text-start align-top">
                      <th scope="col">Email</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody id="result_table" v-html="result_print"></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaffNavbar from "./NavBar_staff.vue";
import Swal from "sweetalert2";

export default {
  name: "StaffPageStaffSetting",
  components: {
    StaffNavbar,
  },
  data() {
    return {
      totalUser: 0,
      result_print: "",
    };
  },
  methods: {
    async getStaffEmail() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/get/staff/email`,
          {
            method: "GET",
            credentials: "include",
          }
        );

        if (response.ok) {
          const staticData = await response.json();
          this.updateTable(staticData);
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async addAdminEmail() {
      const { value: email } = await Swal.fire({
        title: "เพิ่มอีเมลผู้ดูแล",
        input: "email",
        inputLabel: "กรอกอีเมลของผู้ดูแล",
        inputPlaceholder: "example@mfu.ac.th",
        showCancelButton: true,
        confirmButtonText: "เพิ่ม",
        cancelButtonText: "ยกเลิก",
      });

      if (email) {
        try {
          const response = await fetch(
            `${process.env.VUE_APP_API_BASE_URL}/staff/add/staff/email`,
            {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email }),
            }
          );

          if (response.ok) {
            Swal.fire("สำเร็จ", "เพิ่มอีเมลผู้ดูแลแล้ว", "success");
            this.getStaffEmail();
          } else {
            const errorMsg = await response.text();
            Swal.fire("ล้มเหลว", errorMsg, "error");
          }
        } catch (err) {
          console.error(err);
          Swal.fire("ผิดพลาด", err.message, "error");
        }
      }
    },

    async deleteStaff(id) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/delete/staff/email`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ id }),
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || "Delete failed");
        }

        const result = await response.json();
        Swal.fire("สำเร็จ", result, "success");
        this.getStaffEmail(); // reload table
      } catch (error) {
        console.error("Delete error:", error);
        alert("เกิดข้อผิดพลาดในการลบผู้ดูแล");
      }
    },

    updateTable(value) {
      this.result_print = "";
      this.totalUser = value.length;

      value.forEach((v) => {
        this.result_print += `<tr>`;
        this.result_print += `<td>${v.email}</td>`;
        this.result_print += `<td style="width: 5%; white-space: nowrap; text-align: center;"><button class="btn border-0 p-0" id="btn-delete-${v.id}"><i class="fa-solid fa-trash" style="color: #964040;"></i></button></td>`;
        this.result_print += `</tr>`;
      });

      this.$nextTick(() => {
        value.forEach((v) => {
          const button = document.getElementById(`btn-${v.id}`);
          if (button) {
            button.addEventListener("click", () => {
              window.open(`/staff/info?id=${v.id}&ts=${Date.now()}`, "_blank");
            });
          }

          const buttonDelete = document.getElementById(`btn-delete-${v.id}`);
          if (buttonDelete) {
            buttonDelete.addEventListener("click", () => {
              Swal.fire({
                title: "คุณแน่ใจหรือไม่?",
                html: `
                    <p>พิมพ์ <strong>'ฉันต้องการลบข้อมูล'</strong> เพื่อยืนยันการลบผู้ดูแล</p>
                    <input id="swal-input" class="swal2-input" placeholder="ฉันต้องการลบข้อมูล" />
                    <button id="fill-btn" class="swal2-confirm swal2-styled" style="background-color: #666; margin-top: 10px;">
                      กรอกข้อความอัตโนมัติ
                    </button>
                  `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#964040",
                cancelButtonColor: "#d33",
                cancelButtonText: "ยกเลิก",
                confirmButtonText: "ใช่, ลบเลย!",
                focusConfirm: false,
                preConfirm: () => {
                  const input = document.getElementById("swal-input").value;
                  if (input !== "ฉันต้องการลบข้อมูล") {
                    Swal.showValidationMessage(
                      "คุณต้องพิมพ์ให้ตรง: ฉันต้องการลบข้อมูล"
                    );
                  }
                  return input;
                },
                didOpen: () => {
                  const fillBtn = document.getElementById("fill-btn");
                  fillBtn.addEventListener("click", () => {
                    document.getElementById("swal-input").value =
                      "ฉันต้องการลบข้อมูล";
                  });
                },
              }).then((result) => {
                if (
                  result.isConfirmed &&
                  result.value === "ฉันต้องการลบข้อมูล"
                ) {
                  this.deleteStaff(v.id);
                }
              });
            });
          }
        });
      });
    },
  },
  mounted() {
    this.getStaffEmail();
  },
};
</script>

<style scoped>
.status-open {
  color: green;
  font-weight: bold;
}

.status-closed {
  color: red;
  font-weight: bold;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 0 0;
  text-align: center;
}

.bg-secondary-light {
  background-color: rgba(108, 117, 125, 0.2);
}

input {
  outline: none;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 5px;
  width: 150px;
}

label {
  font-size: 14px;
  margin-bottom: 4px;
}

.form-group {
  margin-bottom: 20px;
  padding: 15px 0 15px 0;
}

.d-flex {
  display: flex;
  align-items: center;
}

.mx-2 {
  margin-left: 10px;
  margin-right: 10px;
}

.mr-3 {
  margin-right: 20px;
}

.ml-3 {
  margin-left: 15px;
}

.mt-3 {
  margin-top: 20px;
}

.custom-button:hover {
  background-color: #218838;
}

.status-container {
  text-align: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}

.radio-container {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.d-flex.align-items-start {
  justify-content: flex-start;
}

.date-input {
  width: 150px;
  text-align: left;
}

.radio-button {
  margin-right: 10px;
  width: 16px;
  height: 16px;
  accent-color: #964040;
}

.auto-status {
  margin-left: 20px;
}
</style>
